export const Api = "https://web-hosting-in-nigeria.com.ng/wp-json/wp/v2/wedevelopers";

export const Api2 = "https://web-hosting-in-nigeria.com.ng/wp-json/wp/v2";